import { styled, css } from 'styled-components';

export const Container = styled.div<{ $useGap: boolean }>`
  ${({ theme: { colors }, $useGap }) => css`
    background: ${colors.brandLight};
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    padding: 0.5rem;
    position: sticky;
    top: 0;
    z-index: 2;

    ${
      $useGap &&
      css`
        gap: 0.5rem;
      `
    }

    @media print {
      padding: 3mm 0;
    }
  `}
`;

export const DayOfWeekLabel = styled.div<{ $isPast: boolean; $isToday: boolean }>`
  ${({ theme: { colors, fontSizes, fontWeights }, $isPast, $isToday }) => css`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.25rem 0.5rem;

    p {
      color: ${colors.brandDarkTint30};
      font-size: ${fontSizes.s12};
      line-height: 1rem;
      margin: 0;
      text-transform: capitalize;

      @media print {
        font-weight: ${fontWeights.semiBold};
        line-height: 1em;
        margin-left: -0.25rem;
        padding: 0;
        text-transform: uppercase;
      }
    }

    span {
      color: ${$isToday ? colors.brandPrimary : colors.brandDark};
      font-size: ${fontSizes.s14};
      font-weight: ${fontWeights.semiBold};
      line-height: 1em;

      @media print {
        color: ${colors.brandDark};
      }
    }

    ${
      $isPast &&
      css`
        opacity: 0.6;
        position: static;
        user-select: none;

        @media print {
          opacity: 1;
        }
      `
    }
  `}
`;
